import { useMutation } from "@apollo/client";
import { DELETE_EXHIBITION_DOCUMENT } from "../../../../../../../graphql/mutation/ExhibitionDocument";
import { Button, IconButton, Modal } from "../../../../../../../components/ui";
import {
  ArrowDownTrayIcon,
  EyeIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { isPreviewableDocument } from "../../../../../../../util/documentPreview";

const Actions = props => {
  const { id, values } = props || {};
  const [deleteDocument, { loading }] = useMutation(
    DELETE_EXHIBITION_DOCUMENT,
    {
      refetchQueries: ["FetchExhibitionDocuments"],
    },
  );
  const canPreviewInModal = isPreviewableDocument(values);

  const modalProps = {
    title: "Are you sure?",
    scale: "sm",
    description: `Would you like to delete document titled '${values?.fileName ?? "n/a"}'?`,
    closeOnBackdrop: true,
    body: ({ closeModal }) => {
      const handleDelete = () => {
        deleteDocument({
          variables: {
            input: { documentPath: id },
          },
        }).then(() => {
          closeModal();
        });
      };

      return (
        <div className="mt-4 flex">
          <Button
            className="mr-3"
            label="Cancel"
            action="default"
            onClick={() => {
              closeModal?.();
            }}
          />
          <Button
            label={loading ? "Deleting" : "Delete"}
            disabled={loading}
            onClick={handleDelete}
          />
        </div>
      );
    },
  };

  const viewModalProps = {
    title: values?.fileName ?? "Document Preview",
    scale: "fullscreen",
    body: () => {
      return (
        <div className="mt-4 h-[85vh] w-full">
          <iframe
            title={values?.fileName ?? "Document Preview"}
            src={values?.viewUrl}
            className="h-full w-full rounded-md border border-gray-200"
          />
        </div>
      );
    },
  };

  if (typeof id !== "number") {
    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid grid-cols-4 gap-4">
            {canPreviewInModal ? (
              <Modal {...viewModalProps}>
                <IconButton variant="clean" title="View Document">
                  <EyeIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
                </IconButton>
              </Modal>
            ) : (
              <IconButton
                variant="clean"
                title="Preview not available for this file type"
              >
                <EyeIcon className={`h-4 w-4 cursor-not-allowed text-gray-300`} />
              </IconButton>
            )}
            <IconButton variant="clean" title="Download Document">
              <ArrowDownTrayIcon
                className={`h-4 w-4 cursor-pointer text-gray-400`}
                onClick={() => {
                  window.open(values?.url, "_blank");
                }}
              />
            </IconButton>
            <Modal {...modalProps}>
              <IconButton variant="clean" title="Delete PDF">
                <TrashIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
              </IconButton>
            </Modal>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
